module.exports = __webpack_public_path__ + "img/logo.714aded3.jpg";